import { render } from "./articleDetail.vue?vue&type=template&id=b19ec9ba&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"

import "./articleDetail.vue?vue&type=style&index=0&id=b19ec9ba&lang=less"
import "./articleDetail.vue?vue&type=style&index=1&id=b19ec9ba&lang=scss&scoped=true"
import "./articleDetail.vue?vue&type=style&index=2&id=b19ec9ba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19ec9ba"]])

export default __exports__